import { BalanceType } from 'data/types'
import omit from 'lodash/omit'

import { BalanceActionType } from './actions'
import * as AT from './actionTypes'

export type BalanceStateType = {
  all: Array<BalanceType>
  localAvailable: number
  localTotal: number
  subscribed?: boolean
}

const initialState = {
  all: [],
  localAvailable: 0,
  localTotal: 0
}

const balance = (
  state: BalanceStateType = initialState,
  action: BalanceActionType
): BalanceStateType => {
  switch (action.type) {
    case AT.SET_SNAPSHOT: {
      return {
        all: action.payload.balances,
        localAvailable: action.payload.localAvailable,
        localTotal: action.payload.localTotal,
        subscribed: state.subscribed
      }
    }

    case AT.SET_SUBSCRIBED: {
      return {
        all: initialState.all,
        localAvailable: initialState.localAvailable,
        localTotal: initialState.localTotal,
        subscribed: true
      }
    }

    case AT.SET_UPDATE: {
      const localAvailable = action.payload.balance.total_available_local
      const localTotal = action.payload.balance.total_balance_local
      const ccyBalance = omit(action.payload.balance, [
        'total_balance_local',
        'total_available_local'
      ])
      const all = [
        ...state.all.filter((item) => item.currency !== action.payload.balance.currency),
        ccyBalance
      ]

      return {
        all,
        localAvailable,
        localTotal,
        subscribed: state.subscribed
      }
    }

    case AT.RESET: {
      return {
        ...state,
        all: [],
        localAvailable: 0,
        localTotal: 0
      }
    }

    default:
      return state
  }
}

export default balance
